<template>
  <div class="sa-ann-detail">
    <button class="sa-ann-detail__back" @click="router.push({ name: 'StoreAdminAnnouncements' })">
      ← 返回公告列表
    </button>

    <div v-if="loading" class="sa-ann-detail__state">載入中…</div>
    <div v-else-if="!announcement" class="sa-ann-detail__state">找不到此公告</div>

    <div v-else class="sa-ann-detail__card">
      <div class="sa-ann-detail__meta">
        <span class="sa-ann-detail__badge">公告</span>
        <span class="sa-ann-detail__date">{{ formatDate(announcement.created_at) }}</span>
      </div>
      <h1 class="sa-ann-detail__title">{{ announcement.title }}</h1>
      <div class="sa-ann-detail__content">{{ announcement.content }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'

const route = useRoute()
const router = useRouter()
const announcement = ref(null)
const loading = ref(false)

function formatDate(dateStr) {
  if (!dateStr) return ''
  return new Date(dateStr).toLocaleDateString('zh-TW', {
    timeZone: 'Asia/Taipei',
    year: 'numeric', month: '2-digit', day: '2-digit'
  })
}

onMounted(async () => {
  loading.value = true
  try {
    const { data } = await axios.get('/api/booking/announcements/active')
    const list = data.announcements || []
    const id = Number(route.params.id)
    announcement.value = list.find(a => a.id === id) || null
  } catch (_) { /* 靜默忽略 */ } finally {
    loading.value = false
  }
})
</script>

<style scoped>
.sa-ann-detail {
  max-width: 760px;
  margin: 0 auto;
}

.sa-ann-detail__back {
  display: inline-flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  color: #8b6f5c;
  font-weight: 600;
  padding: 0;
  margin-bottom: 24px;
  transition: opacity 0.15s;
}
.sa-ann-detail__back:hover { opacity: 0.7; }

.sa-ann-detail__state {
  color: #aaa;
  font-size: 0.95rem;
  padding: 48px 0;
  text-align: center;
}

.sa-ann-detail__card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  padding: 28px 32px;
}

.sa-ann-detail__meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.sa-ann-detail__badge {
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 20px;
  background: #f59e0b;
  color: #fff;
  letter-spacing: 0.03em;
}

.sa-ann-detail__date {
  font-size: 0.82rem;
  color: #aaa;
}

.sa-ann-detail__title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 20px;
  line-height: 1.5;
}

.sa-ann-detail__content {
  font-size: 0.93rem;
  color: #444;
  white-space: pre-wrap;
  line-height: 1.9;
}
</style>
